module.exports = __webpack_public_path__ + "img/chevron-green.839e5ee5.svg";